import React from "react";
import MachineList from "./machine-list";
import NearbyStores from "../stores/nearby-stores";

export default function() {
  return (
    <div>
      <NearbyStores baseUrl={"machines"} />
      <MachineList />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/machines/view.js